'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'InvestorCountryRestService',
    function ($modal, InvestorCountryRestService) {

        return {
            edit: edit,
            create: create,
            api: InvestorCountryRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/investor-country-modal-create.html'),
                controller: 'InvestorCountryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    investorCountry: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/investor-country-modal-create.html'),
                controller: 'InvestorCountryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    investorCountry: function () {
                        return item;
                    }
                }
            });
        }

    }];